/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiOperatorFromJSON, ApiOperatorToJSON, } from './ApiOperator';
import { ApiSessionConditionCustomFromJSON, ApiSessionConditionCustomToJSON, } from './ApiSessionConditionCustom';
export function ApiSessionEffectivenessConditionPayloadFromJSON(json) {
    return ApiSessionEffectivenessConditionPayloadFromJSONTyped(json, false);
}
export function ApiSessionEffectivenessConditionPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conversionId': !exists(json, 'conversionId') ? undefined : json['conversionId'],
        'custom': !exists(json, 'custom') ? undefined : ApiSessionConditionCustomFromJSON(json['custom']),
        'operator': !exists(json, 'operator') ? undefined : ApiOperatorFromJSON(json['operator']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiSessionEffectivenessConditionPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conversionId': value.conversionId,
        'custom': ApiSessionConditionCustomToJSON(value.custom),
        'operator': ApiOperatorToJSON(value.operator),
        'value': value.value,
    };
}
